import { useAuth } from '../AuthProvider'; 
import { useState, useEffect } from 'react';
import { Navigate, Link } from 'react-router-dom';
import { Book, ArrowLeft } from 'lucide-react';
import { Logo } from '../components/Logo';

export default function Login(){
  const {magic, user}=useAuth(); 
  const[email,setEmail]=useState(''); 
  const[sent,setSent]=useState(false);
  const[error,setError]=useState('');
  
  // Prefill email from query parameter if present (e.g., after invite flow)
  useEffect(() => {
    try {
      const sp = new URLSearchParams(window.location.search)
      const qEmail = sp.get('email')
      if (qEmail) setEmail(qEmail)
    } catch {}
  }, [])
  
  console.log('🔐 Login: Render - User state:', user ? 'logged in' : 'not logged in')
  
  // Redirect to dashboard if already logged in
  if (user) {
    console.log('🔐 Login: User is logged in, redirecting to dashboard')
    return <Navigate to="/qr/dash" replace />;
  }
  
  const submit=async(e: any)=>{
    e.preventDefault();
    console.log('🔐 Login: Sending magic link to:', email)
    
    try {
      setError('')
      const result = await magic(email);
      console.log('🔐 Login: Magic link result:', result)
      
      if (result.error) {
        console.error('🔐 Login: Magic link error:', result.error)
        setError(result.error.message || 'Fehler beim Senden der E-Mail')
      } else {
        console.log('🔐 Login: Magic link sent successfully')
        setSent(true);
      }
    } catch (err) {
      console.error('🔐 Login: Exception during magic link:', err)
      setError('Unerwarteter Fehler beim Senden der E-Mail')
    }
  };
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4" data-testid="login-page">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-8">
        {/* Logo */}
        <div className="text-center mb-8">
          <Logo size={60} className="mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-gray-900">BeyondPages</h1>
          <p className="text-gray-600 mt-2">QR-Code Management System</p>
        </div>

        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
          Anmelden bei QR Management
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Verwalten Sie Ihre QR-Codes und Links
        </p>

        <div className="mt-8">
          {sent ? (
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
                <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Magic Link gesendet!
              </h3>
              <p className="text-sm text-gray-600 mb-4">
                Prüfen Sie Ihr Postfach und klicken Sie auf den Link, um sich anzumelden.
              </p>
              <button
                onClick={() => setSent(false)}
                className="text-blue-600 hover:text-blue-500 text-sm font-medium"
              >
                Erneut senden
              </button>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-6">
              {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded" data-testid="login-error">
                  {error}
                </div>
              )}
              
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                  E-Mail-Adresse
                </label>
                <div className="mt-1">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    value={email}
                    onChange={e=>setEmail(e.target.value)}
                    placeholder="ihre.email@beispiel.de"
                    className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                    data-testid="login-email"
                  />
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="flex w-full justify-center rounded-md border border-transparent bg-blue-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
                  data-testid="login-submit"
                >
                  Magic Link senden
                </button>
              </div>

              <div className="text-center">
                <p className="text-xs text-gray-500">
                  Sie erhalten einen sicheren Login-Link per E-Mail.<br/>
                  Kein Passwort erforderlich.
                </p>
                <p className="text-xs text-gray-500 mt-4">
                  Mit der Anmeldung akzeptieren Sie unsere{' '}
                  <Link to="/terms" className="text-blue-600 hover:text-blue-700">Nutzungsbedingungen</Link>
                  {' '}und{' '}
                  <Link to="/privacy" className="text-blue-600 hover:text-blue-700">Datenschutzerklärung</Link>.
                </p>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
} 
